import * as actionType from '@lib/actions/AuthenticationActionType';
import { Dispatch } from 'react-redux';
import { ActionCreator } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { IStoreAuthenticationState } from 'types';
import * as Api from './API';
import { asyncFirmwareVersionAction, fetchCallWithSessionCheck } from './SiteAction';
import { PUSH_DEVICES_OF_USER } from './SiteActionType';

export const signOutAction: ActionCreator<actionType.ISignOutAction> = () => ({
  payload: {
  },
  type: actionType.SIGN_OUT_ACTION
});

export const registerAction: ActionCreator<actionType.IRegisterNavigateAction> = () => ({
  payload: {
  },
  type: actionType.RESGITER_NAVIGATE_ACTION
});

export const lostPasswordAction: ActionCreator<actionType.ILostPasswordNavigateAction> = () => ({
  payload: {
  },
  type: actionType.LOST_PASSWORD_NAVIGATE_ACTION
});

// Async Register Redux-Thunk action
export const asyncRegisterAction: ActionCreator<
  ThunkAction<Promise<actionType.IRegisterAction>, IStoreAuthenticationState, void>
  > = (login: string, password: string) => {
    return async (dispatch: Dispatch<IStoreAuthenticationState>): Promise<actionType.IRegisterAction> => {
      try {
        const response = await fetchCallWithSessionCheck(dispatch, Api.API_BASE_URL + Api.API_METHOD_REGISTER, true,
          {
            body: JSON.stringify({ 'email': login, 'password': password }),
            credentials: Api.API_CREDENTIALS,
            headers: Api.API_HEADERS,
            method: Api.API_VERB_POST
          });
        if (response.status === 200) {
          // After registration, login
          return dispatch(asyncSigninAction(login, password));
        } else {
          const data = await response.json();
          return dispatch({
            error: true,
            errorMessage: data.message,
            type: actionType.RESGITER_ACTION
          });
        }
      } catch (e) {
        return dispatch({
          error: true,
          errorMessage: 'NETWORK',
          type: actionType.RESGITER_ACTION
        });
      }
    };
  };

// Async SignIn Redux-Thunk action
export const asyncSigninAction: ActionCreator<
  ThunkAction<Promise<actionType.ISignInAction>, IStoreAuthenticationState, void>
  > = (login: string, password: string, rememberMe: boolean) => {
    return async (dispatch: Dispatch<IStoreAuthenticationState>): Promise<actionType.ISignInAction> => {
      try {
        const response = await fetchCallWithSessionCheck(dispatch, Api.API_BASE_URL + Api.API_METHOD_LOGIN, true,
          {
            body: JSON.stringify({ 'email': login, 'password': password }),
            credentials: Api.API_CREDENTIALS,
            headers: Api.API_HEADERS,
            method: Api.API_VERB_POST
          });
        if (response.status === 200) {
          const data = await response.json();
          // Retrieve last firmwares version
          dispatch(asyncFirmwareVersionAction());
          // Register device
          // dispatch(asyncDeviceRegisterAction());
          // Dispath push devices
          dispatch({
            payload: {
              pushDevices: data.pushDevices
            },
            type: PUSH_DEVICES_OF_USER
          })
          for (const site of data.sites) {
            site.notif = site.device.alarms.length;
          }
          return dispatch({
            error: false,
            errorMessage: '',
            payload: {
              login,
              password,
              profile: data.profile,
              rememberMe,
              sites: data.sites
            },
            type: actionType.SIGN_IN_ACTION
          });
        } else {
          return dispatch({
            error: true,
            errorMessage: '' + response.status,
            type: actionType.SIGN_IN_ACTION
          });
        }
      } catch (e) {
        return dispatch({
          error: true,
          errorMessage: 'NETWORK',
          type: actionType.SIGN_IN_ACTION
        });
      }
    };
  };

// Async SendPassword Redux-Thunk action
export const asyncSendPasswordAction: ActionCreator<
  ThunkAction<Promise<actionType.ISendPasswordAction>, IStoreAuthenticationState, void>
  > = (login: string) => {
    return async (dispatch: Dispatch<IStoreAuthenticationState>): Promise<actionType.ISendPasswordAction> => {
      try {
        const response = await fetchCallWithSessionCheck(dispatch, Api.API_BASE_URL + Api.API_METHOD_LOST_PASSWORD, true,
          {
            body: JSON.stringify({ 'email': login }),
            credentials: Api.API_CREDENTIALS,
            headers: Api.API_HEADERS,
            method: Api.API_VERB_POST
          });
        if (response.status === 200) {

          return dispatch({
            error: false,
            errorMessage: '',
            payload: {},
            type: actionType.SEND_PASSSWORD_ACTION
          });
        } else {
          const data = await response.json();
          return dispatch({
            error: true,
            errorMessage: data.message,
            payload: {},
            type: actionType.SEND_PASSSWORD_ACTION
          });
        }
      } catch (e) {
        return dispatch({
          error: true,
          errorMessage: 'NETWORK',
          payload: {},
          type: actionType.SEND_PASSSWORD_ACTION
        });
      }
    };
  };


// Async SendPassword Redux-Thunk action
export const asyncChangePasswordAction: ActionCreator<
  ThunkAction<Promise<actionType.IChangePasswordAction>, IStoreAuthenticationState, void>
  > = (oldPassword: string, newPassword: string) => {
    return async (dispatch: Dispatch<IStoreAuthenticationState>): Promise<actionType.IChangePasswordAction> => {
      try {
        const response = await fetchCallWithSessionCheck(dispatch, Api.API_BASE_URL + Api.API_METHOD_CHANGE_PASSWORD, true,
          {
            body: JSON.stringify({ 'oldPassword': oldPassword, 'newPassword': newPassword }),
            credentials: Api.API_CREDENTIALS,
            headers: Api.API_HEADERS,
            method: Api.API_VERB_PUT
          });
        if (response.status === 200) {
          return dispatch({
            error: false,
            errorMessage: '',
            payload: {},
            type: actionType.CHANGE_PASSSWORD_ACTION
          });
        } else {
          const data = await response.json();
          return dispatch({
            error: true,
            errorMessage: data.message,
            payload: {},
            type: actionType.CHANGE_PASSSWORD_ACTION
          });
        }
      } catch (e) {
        return dispatch({
          error: true,
          errorMessage: 'NETWORK',
          payload: {},
          type: actionType.CHANGE_PASSSWORD_ACTION
        });
      }
    };
  };



// WEBPACK FOOTER //
// ./src/actions/AuthenticationAction.tsx